import {Component, OnInit} from '@angular/core';
import {PrlAccountDataService} from '../../../../prl-dashboard/services/account/prl-account-data.service';
import {ManagerInfoObj, MxNotificationService} from 'mx-core';

@Component({
    selector: 'prl-manager-info',
    standalone: false,
    templateUrl: './prl-manager-info.component.html',
    styleUrl: './prl-manager-info.component.scss',
})
export class PrlManagerInfoComponent implements OnInit {
    obj: ManagerInfoObj | null = null;

    constructor(private readonly dataService: PrlAccountDataService,
                private readonly notificationService: MxNotificationService) {
    }

    ngOnInit(): void {
        this.dataService.getManagerInfo().subscribe((obj: ManagerInfoObj) => {
            if (obj) {
                this.obj = obj;
            } else {
                this.notificationService
                    .showMessageDialog('Error', 'No Account Manager was assigned to your account. Please contact support', 'error');
            }
        });
    }

}
